import { Component } from 'react'
import firebase from "../firebase/FirebaseProvider";
import { store } from '../redux/store';
import * as ChatActions from '../redux/actions/chat';
import { withRouter } from 'react-router';

class AuthListener extends Component {
    componentWillMount() {
        this.authListener = this.authListener.bind(this);
        this.authListener();
    }

    authListener() {
      firebase.auth().onAuthStateChanged((user) => {
          if (user) {
              localStorage.setItem('user_id', user.uid);
              console.log("auth provider:", user.providerData[0].providerId);
              user.getIdToken().then(function(idToken) {
                console.log(idToken);
              });
              store.dispatch(ChatActions.setUserToState({
                  user_id: user.uid,
                  displayName: user.displayName,
                  provider: user.providerData[0].providerId,
                  isVerified: user.emailVerified
              }));
              //console.log('user changed..', user);
              //self.props.history.push("/");
          } else {
              store.dispatch(ChatActions.clearUserFromState());
              console.log('user not changed..', user);
          }
      });
    }

    render() {
        return (
            null
        );
    }
}

export default withRouter(AuthListener);